import React from 'react';
import styled from '@emotion/styled';

interface ProductCardProps {
  category: string;
  name: string;
  details: string;
  image?: string;
}

const placeholderImg = 'https://picsum.photos/600/400';

export const ProductCard: React.FC<ProductCardProps> = ({category, name, details, image }) => {
  
  // 이미지 경로가 제공되면 사용, 아니면 기본 이미지 사용
  const imageSrc = image || placeholderImg;

  return (
    <Container>
      <ProductImageContainer>
        <ProductImage src={imageSrc} alt={name}
        onError={(e) => {
          console.log('이미지 로드 실패, 기본 이미지로 대체');
          e.currentTarget.src = placeholderImg;
        }}
        />
      </ProductImageContainer>
      <ProductInfo>
        <ProductCategory>{category}</ProductCategory>
        <ProductName>{name}</ProductName>
        <ProductDetails>{details}</ProductDetails>
      </ProductInfo>
    </Container>
  );
};

const Container = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
`;

const ProductImageContainer = styled.div`
  width: 80px;
  height: 80px;
  margin-right: 16px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const ProductInfo = styled.div`
  flex: 1;
`;

const ProductCategory = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
`;

const ProductName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
`;

const ProductDetails = styled.p`
  font-size: 14px;
  color: #333;
`;